import { apiClient } from './client';
import type { Product } from '../../types';

export const productsService = {
  list: async (params?: { limit?: number; offset?: number; status?: string }): Promise<{ products: Product[] }> => {
    return apiClient.get<{ products: Product[] }>('/api/v1/products', params);
  },

  getById: async (id: string): Promise<Product> => {
    return apiClient.get<Product>(`/api/v1/products/${id}`);
  },

  create: async (input: { name: string; sku: string; description?: string; offlineGracePeriodHours?: number; isDemo?: boolean }): Promise<Product> => {
    return apiClient.post<Product>('/api/v1/products', input);
  },

  update: async (id: string, input: Partial<Product>): Promise<Product> => {
    return apiClient.patch<Product>(`/api/v1/products/${id}`, input);
  },
};
